import { render, staticRenderFns } from "./TrapezGS.vue?vue&type=template&id=36dcd628&"
import script from "./TrapezGS.vue?vue&type=script&lang=js&"
export * from "./TrapezGS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports